<template>
  <div class="con">
    <div class="con-wrap">
      <div class="title">{{ title }}</div>
      <div class="con_box">
        <div class="bar-list">
          <div
            @click="selectBar(index)"
            :class="['bar', actIndex === index ? 'active' : '']"
            v-for="(item, index) in orgTypeList"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <div ref="mySwiper" class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(img, index) in imgs" :key="index">
              <img class="img" :src="img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'

export default {
  props: {
    title: String,
    orgTypeList: Array,
    imgs: Array,
  },
  data() {
    return {
      actIndex: 0,
      mySwiper: '',
    }
  },
  mounted() {
    let that = this
    this.mySwiper = new Swiper('.swiper-container', {
      direction: 'horizontal', // 垂直切换选项
      loop: false, // 循环模式选项
      // pagination: { el: '.swiper-pagination' },
      autoplay: false,
      on: {
        slideChange: function() {
          that.actIndex = this.activeIndex
        },
      },
    })
    // console.info(swiper)
  },
  methods: {
    // 选中tab
    selectBar(index) {
      if (this.activeIndex !== index) {
        this.activeIndex = index
        this.mySwiper.slideTo(index, 1000, false)
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../../../assets/css/swiper.min.css';
.con {
  background-color: #fff;
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .con-wrap {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .title {
    text-align: center;
    font-size: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 50px;
    margin-bottom: 60px;
  }
  .con_box {
    .bar-list {
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid rgba(153, 153, 153, 0.3);
      margin-bottom: 19px;
      padding-bottom: 29px;
      .active {
        color: #E61717;
        &::after {
          content: ' ';
          width: 64px;
          height: 3px;
          background: #E61717;
          position: absolute;
          bottom: -29px;
          left: 0;
        }
      }
      .bar {
        position: relative;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        margin-right: 50px;
        cursor: default;
        &:hover {
          color: #E61717;
          &::after {
            content: ' ';
            width: 64px;
            height: 3px;
            background: #E61717;
            position: absolute;
            bottom: -29px;
            left: 0;
          }
        }
      }
    }
    .swiper-container {
      width: 1200px;
    }
  }
}
</style>
